import React from "react";
import { Link } from "react-router-dom";
import { policyCatalogGroups } from "../Datas/policyData";
import siteConfig from "../config/siteConfig";
import "../css/policy-library.scss";

function PolicyHub() {
  const contact = siteConfig.contact || {};
  const lastUpdated = siteConfig.policyLastUpdated || "16 October 2026";

  return (
    <main className="content-page policy-hub-page">
      <header className="page-hero">
        <div className="page-shell page-hero__content">
          <p className="eyebrow">Customer care &amp; legal</p>
          <h1>Store policies, all in one place.</h1>
          <p className="page-hero__lede">
            Clear information about shopping, payments, delivery, food safety,
            privacy, website use, and your rights.
          </p>
          <p className="policy-document-page__updated">
            Policy library updated: {lastUpdated}
          </p>
        </div>
      </header>

      <section className="page-section page-shell policy-hub-page__intro">
        <div>
          <p className="eyebrow">A useful starting point</p>
          <h2>Find the policy that fits your question.</h2>
        </div>
        <div className="prose">
          <p>
            These policies are written for {siteConfig.brandName} and reflect
            the features currently shown in this storefront. Feature-specific
            policies apply only when that feature—such as a pre-order or gift
            card—is expressly offered.
          </p>
          <p>
            No policy limits a consumer right that cannot lawfully be excluded.
            If you are unsure which policy applies, email{" "}
            <a href={`mailto:${contact.email}`}>{contact.email}</a>.
          </p>
        </div>
      </section>

      <div className="policy-hub-page__groups">
        {policyCatalogGroups.map((group, groupIndex) => (
          <section
            className={groupIndex % 2 ? "page-section page-section--tinted" : "page-section"}
            id={`policy-group-${group.id}`}
            key={group.id}
          >
            <div className="page-shell policy-hub-page__group">
              <header>
                <p className="eyebrow">{String(groupIndex + 1).padStart(2, "0")}</p>
                <h2>{group.title}</h2>
                <p>{group.description}</p>
              </header>
              <div className="policy-hub-page__grid">
                {group.items.map((item) => (
                  <Link className="policy-hub-card" to={item.path} key={item.path}>
                    <span>{item.title}</span>
                    <p>{item.description}</p>
                    <strong aria-hidden="true">Read policy →</strong>
                  </Link>
                ))}
              </div>
            </div>
          </section>
        ))}
      </div>
    </main>
  );
}

export default PolicyHub;
